import React from 'react';
import { Link } from 'react-router-dom';
import { MdArrowForward } from 'react-icons/md';
import '../../styles/home/LocationsSection.css';

const contactItems = [
  { emoji: '📞', label: 'PHONE', value: '5028074201' },
  { emoji: '✉️', label: 'EMAIL', value: 'info@vindistro.com' },
  { emoji: '🕐', label: 'HOURS', value: 'Monday – Saturday, 7 AM – 8 PM' },
];

const LocationsSection: React.FC = () => {
  return (
    <section className="support">
      <div className="support__container">
        {/* ── Left Content ── */}
        <div className="support__content">
          <span className="support__tag">SUPPORT</span>
          <h2 className="support__heading">
            We're here<br />when it matters
          </h2>
          <p className="support__subtitle">
            Our partner support team operates across extended hours —
            because your business doesn't stop at 5pm, and neither do
            we. Every query is handled by a real person who knows your
            account.
          </p>

          <div className="support__contacts">
            {contactItems.map((item) => (
              <div key={item.label} className="support__contact">
                <span className="support__contact-icon">{item.emoji}</span>
                <div className="support__contact-text">
                  <span className="support__contact-label">{item.label}</span>
                  <span className="support__contact-value">{item.value}</span>
                </div>
              </div>
            ))}
          </div>

          <Link to="/contact" className="support__cta">
            Get in Touch <MdArrowForward />
          </Link>
        </div>

        {/* ── Right: Image + Floating Card ── */}
        <div className="support__visual">
          <div className="support__image-wrap">
            <img
              src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600"
              alt="Support handshake"
              className="support__image"
              loading="lazy"
            />
          </div>
          <div className="support__float-card">
            <span className="support__float-icon">⚡</span>
            <div className="support__float-text">
              <span className="support__float-title">Average response time: 1 Business Day</span>
              <span className="support__float-desc">For urgent issues, please call us directly</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationsSection;
